import * as types from '../ActionTypes/BookedUsersActionTypes';

export class BookedUsersActionCreators {
    static getUsers = workoutId => ({
        type: types.GET_BOOKED_USERS,
        meta: { workoutId },
    });

    static getUsersSuccess = response => {
        return {
            type: types.GET_BOOKED_USERS + types.SUCCESS,
            payload: [...response],
        };
    };

    static getUsersEmpty = () => {
        return {
            type: types.GET_BOOKED_USERS + types.EMPTY,
        };
    };

    static getUsersError = err => {
        return {
            types: types.GET_BOOKED_USERS + types.FAIL,
        };
    };
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/BookedUsersActionCreators.js